import { AuthRefusalReason } from '@depanneo/types'

export const LOGIN_PATH = '/login'

export const LOGIN_REASON_PARAM = 'reason'

export const LOGIN_REFUSAL_MESSAGES: Record<AuthRefusalReason, string> = {
  [AuthRefusalReason.ORGANIZATION_INACTIVE]:
    'Votre organisation est désactivée. Contactez Depanneo pour la réactiver.',
}

export const isAuthRefusalReason = (
  value: unknown
): value is AuthRefusalReason =>
  Object.values(AuthRefusalReason).includes(value as AuthRefusalReason)

export const authRefusalReasonOf = (error: unknown) => {
  const reason = (
    error as { response?: { data?: { details?: { reason?: unknown } } } }
  )?.response?.data?.details?.reason
  return isAuthRefusalReason(reason) ? reason : undefined
}
